import React, { memo } from "react";

import "./HawkeyeUser.scss";

function HawkeyeUser(props) {
  const { userInfo, logout, isLogoutDisabled } = props;

  if (userInfo) {
    return (
      <div className="hawkeye-user">
        {userInfo.profilePhoto ? (
          <img className="hawkeye-user-avatar" src={userInfo.profilePhoto} />
        ) : (
          <span className="hawkeye-user-avatar">{userInfo.name.charAt(0)}</span>
        )}
        <div className="hawkeye-user-info">
          <p className="hawkeye-user-greetings">{userInfo.name}</p>
          {!isLogoutDisabled && (
            <a className="hawkeye-action" tabIndex="0" onClick={logout}>
              {AxiomAPIs.translate("Logout")}
            </a>
          )}
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default memo(HawkeyeUser);
